import {useGetAndSet} from "./useGetAndSet";
import {createSetSummaryFiguresDataAction} from "../actions/dataActions";


export function useSummaryFiguresData(params, dataFresh){
    return useGetAndSet("summaryfigures", params, createSetSummaryFiguresDataAction, dataFresh);
}